// removed by extract-text-webpack-plugin
module.exports = {"container":"photo-upload__container__3r5vC","add-photos-button":"photo-upload__add-photos-button__t2QrF","click-overlay":"photo-upload__click-overlay__3MPwi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/media/photo-upload.scss
// module id = 1435
// module chunks = 1